import * as React from 'react'
import { RenderElementProps } from 'slate-react'

const CodeBlockElement = ({ attributes, children }: RenderElementProps) => {
  return (
    <pre {...attributes}>
      <code>{children}</code>
    </pre>
  )
}

export default CodeBlockElement
